import React, { Component } from "react";
import TextInputField, { Props as TFProps } from "./TextInputField";
import { DefaultProps } from "@eres/forms";

export interface Props extends TFProps {
	containerClassName?: string;
	inputGroupClassName?: string;
	inputClassName?: string;
	currencyTypeClassName?: string;
	errorInputClass?: string;
	placeHolder?: string;
	currencyType?: string;
}

interface State {
}

export default class TextAreaInputField extends Component<Props, State> {
	static defaultProps: DefaultProps<Props> = {
		valueConverter: []
	};

	render() {
		return <TextInputField
			customInput={ <textarea className="form-control" rows={ 3 }/> }
			{ ...this.props }/>;
	}

}
